/**
 * The phone's sub-region chips pick one sub-region, while the page's state
 * records the hidden ones, as the desktop legend does. These translate between
 * the two, so both layouts share one filter.
 */
import type { SubregionFilter } from '../../primitives/subregion-filter';

/** The chip that is on: the one sub-region left showing, or null when that is not the case. */
export function pickedSubregion({ subregions, hidden }: SubregionFilter): string | null {
  const showing = subregions.filter((s) => !hidden.has(s.label));
  return hidden.size > 0 && showing.length === 1 ? showing[0].label : null;
}

/** The hidden list that shows only `label`, or nothing hidden for null. */
export function hiddenForPick({ subregions }: SubregionFilter, label: string | null): string[] {
  return label === null ? [] : subregions.map((s) => s.label).filter((l) => l !== label);
}
